import { render, staticRenderFns } from "./CafeteriaModuleLayout.vue?vue&type=template&id=2387ada3"
import script from "./CafeteriaModuleLayout.vue?vue&type=script&lang=js"
export * from "./CafeteriaModuleLayout.vue?vue&type=script&lang=js"
import style0 from "./CafeteriaModuleLayout.vue?vue&type=style&index=0&id=2387ada3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports